// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3Z55m","avatar":"style_avatar__31U9U"};